"use strict";const a=require("./generateUtilityClass-ad9110b0.js");function n(s,i,r="Mui"){const e={};return i.forEach(t=>{e[t]=a.generateUtilityClass(s,t,r)}),e}exports.generateUtilityClasses=n;
